import { render, staticRenderFns } from "./MdChart.vue?vue&type=template&id=2b973364&scoped=true"
import script from "./MdChart.vue?vue&type=script&lang=js"
export * from "./MdChart.vue?vue&type=script&lang=js"
import style0 from "./MdChart.vue?vue&type=style&index=0&id=2b973364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b973364",
  null
  
)

export default component.exports